export default "__VITE_ASSET__CYeCfQE$__"